export const argsToString = (args = {}) => {
  const keys = Object.keys(args);
  if (keys.length === 0) return '';
  return '?' + keys.map(key => `${key}=${JSON.stringify(args[key])}`).join('&');
};

const handleErrors = async (res, path) => {
  if (res.ok) return res;

  let error = new Error('Unknown Error');
  const respJson = await res.json();
  error.statusCode = respJson.error.statusCode || res.status;
  // switch (error.statusCode) {
  //   case 401:
  //     error = new Error('Forbidden');
  //     break;
  //   case 403:
  //     error = new Error('Forbidden');
  //     break;
  //   case 404:
  //     error = new Error('Not Found');
  //     break;
  //   case 422:
  error = new Error(respJson.error.message);
  error.name = respJson.error.name;
  error.details = respJson.error.details;
  //     break;
  //   case 500:
  //     error = new Error('Internal Server Error');
  //     break;
  //   default:
  // }
  error.response = res;
  // error.statusCode = res.status;
  throw error;
};

const parseValue = (res, parseAsJson = true) => {
  if (res.status === 204) return {};
  return parseAsJson ? res.json() : res.text();
};

function fetch2(
  path,
  params = null,
  method = METHOD.GET,
  body,
  fetchOptions = { parseJson: true }
) {
  const options = {
    method,
    headers: Object.assign(
      {},
      {
        Accept: 'application/json, text/plain, */*',
        'Content-Type': 'application/json',
      }
    ),
    credentials: 'include',
  };
  if (body) {
    options.body = JSON.stringify(body);
  }

  const callPath = params ? `${path}${argsToString(params)}` : path;

  // console.log('url is ', method, callPath, body);

  return fetch(callPath, options)
    .then(res => handleErrors(res, callPath))
    .then(res => parseValue(res, fetchOptions.parseJson));
}

export const METHOD = {
  GET: 'GET',
  POST: 'POST',
  PATCH: 'PATCH',
  PUT: 'PUT',
  DELETE: 'DELETE',
};

export default fetch2;
